module.exports = __webpack_public_path__ + "static/img/4道田.58f79c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo/4道田.jpg
// module id = iB8n
// module chunks = 0